import { useStreamDonations } from './useStreamDonations.js'

export default {
    name: 'StreamDonationOverview',
    props: {
        variation: {
            type: String,
            default: 'dark'
        },
        donationPosition: {
            type: String,
            default: 'above'
        },
        fundraisingId: {
            type: String,
            default: ''
        },
        footerText: {
            type: String,
            default: ''
        },
        minNyDonationSek: {
            type: Number,
            default: 2
        },
        maxNyDonationSek: {
            type: Number,
            default: 10
        },
        donationStyle: {
            type: String,
            default: 'normal'
        }
    },
    setup(props) {
        const {
            name,
            totalAmount,
            targetAmount,
            progressPercent,
            currentNew,
            previousDonations
        } = useStreamDonations(props)

        return {
            name,
            totalAmount,
            targetAmount,
            progressPercent,
            footerText: props.footerText,
            currentNew,
            previousDonations,
            donationStyle: props.donationStyle
        }
    }
}
